import { AfterViewInit, Component, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { CustomSiteContext } from '@app/services';
import {
  ContentfulDynamicComponentRestService,
  ContentfulRestService,
} from 'haba-contentful-components';
import { Subscription } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatalogFormComponent } from '../catalog-form/catalog-form.component';

@Component({
  selector: 'app-catalog-page',
  templateUrl: './catalog-page.component.html',
  styleUrls: ['./catalog-page.component.scss'],
  imports: [CatalogFormComponent],
})
export class CatalogPageComponent implements AfterViewInit, OnDestroy {
  @ViewChild('container', { read: ViewContainerRef })
  public target: ViewContainerRef;
  public content;
  private catalogData$: Subscription;

  constructor(
    private contentfulRestService: ContentfulRestService,
    private contentfulDynamicComponentRestService: ContentfulDynamicComponentRestService,
    private siteContextService: CustomSiteContext
  ) {}

  ngAfterViewInit(): void {
    this.catalogData$ = this.siteContextService
      .getActive()
      .pipe(
        concatMap(() => {
          return this.contentfulRestService
            .getCatalogPage({
              space: environment.contentful.spaceId,
              accessToken: environment.contentful.token,
              environment: environment.contentful.environment,
            })
            .pipe(map((catalogData) => (catalogData ? [catalogData] : [])));
        })
      )
      .subscribe((content) =>
        this.contentfulDynamicComponentRestService.renderComponents(content, this.target)
      );
  }

  ngOnDestroy() {
    this.catalogData$?.unsubscribe();
  }
}
